module.exports = ".prime-form {\n  margin-bottom: 30px; }\n\n::ng-deep.has-error .ui-dropdown {\n  border: 1.5px solid #FF1744 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/formulario/input-prime-dropdown/input-prime-dropdown.component.scss
// module id = ./src/app/components/formulario/input-prime-dropdown/input-prime-dropdown.component.scss
// module chunks = main